// Action type constants for reducers
export const LOAD = 'LOAD';
export const REQUEST_REGISTER = 'REQUEST_REGISTER';
export const REGISTER_USER = 'REGISTER_USER';
export const REGISTER_SUCCESS = 'REGISTER_SUCCESS';
export const REGISTER_ERROR = 'REGISTER_ERROR';
export const UPDATE_USERNAME = 'UPDATE_USERNAME';
export const UPDATE_PASSWORD = 'UPDATE_PASSWORD';
export const UPDATE_EMAIL = 'UPDATE_EMAIL';
export const SHOW_ERROR = 'SHOW_ERROR';
export const TOGGLE_PASSWORD_VISIBILITY = 'TOGGLE_PASSWORD_VISIBILITY';
export const RESET_AUTH_FORM = 'RESET_AUTH_FORM';
export const GO_TO_NEXT = 'GO_TO_NEXT';
export const GO_TO_PREVIOUS = 'GO_TO_PREVIOUS';
export const LOAD_TAB = 'LOAD_TAB';
export const IDEA_CREATION_UPDATE_TITLE = 'IDEA_CREATION_UPDATE_TITLE';
export const IDEA_CREATION_UPDATE_CATEGORY = 'IDEA_CREATION_UPDATE_CATEGORY';
export const IDEA_CREATION_UPDATE_ABOUT = 'IDEA_CREATION_UPDATE_ABOUT';
export const IDEA_CREATION_UPDATE_MODE = 'IDEA_CREATION_UPDATE_MODE';
export const IDEA_CREATION_UPDATE_ACTION = 'IDEA_CREATION_UPDATE_ACTION';
export const SET_EDITTING = 'SET_EDITTING';
export const SET_PERSON = 'SET_PERSON';
export const SET_SEED = 'SET_SEED';
export const CLEAR_ERROR = 'CLEAR_ERROR';
export const LOAD_OWNER_PK = 'LOAD_OWNER_PK';
export const LOAD_USERNAME = 'LOAD_USERNAME';
export const UPDATE_SEED = 'UPDATE_SEED';
